export { default } from './DetailLogMerchant';
